import { c as _c } from "react/compiler-runtime";
import { UserProfile } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "@pages/account-settings/user-provider";
import { BrowserUtils } from "@stellar/utils";
import { useAppSelector } from "@store/store-helper";
import { isUserLoggedInSelector } from "@store/user/user-selector";

/** Custom hook returning the account settings close handler */
export function useCloseAccountSettings() {
  const $ = _c(6);
  const {
    trackEvent
  } = useTrackEvent();
  const navigate = useNavigate();
  const {
    navigateToRoot
  } = useAppNavigation();
  const {
    originUrl
  } = useUserContext();
  const isUserLoggedIn = useAppSelector(isUserLoggedInSelector);
  let t0;
  if ($[0] !== isUserLoggedIn || $[1] !== navigate || $[2] !== navigateToRoot || $[3] !== originUrl || $[4] !== trackEvent) {
    const onCloseButtonClick = function onCloseButtonClick() {
      trackEvent({
        name: UserProfile.closeAccount,
        props: {
          isUserLoggedIn
        }
      });
      if (BrowserUtils.isInIframe()) {
        const message = {
          action: "closeSettingPage"
        };
        window.parent.postMessage(message, "*");
        return;
      }
      if (originUrl) {
        navigate(originUrl);
      } else {
        navigateToRoot();
      }
    };
    t0 = {
      onCloseButtonClick
    };
    $[0] = isUserLoggedIn;
    $[1] = navigate;
    $[2] = navigateToRoot;
    $[3] = originUrl;
    $[4] = trackEvent;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
}